import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MiniUserModel } from '../shared/data/models/mini-user.model';
import { InitialUnreadCountModel } from '../shared/data/models/initial-unread-count.model';

export interface State {
  user?: MiniUserModel;
  showPassword?: boolean;
  isAuthenticated?: boolean;
  userLoading?: boolean;
  userError?: string;
  notificationCount?: InitialUnreadCountModel;
}

// selectors function
const getAppFeatureStore = createFeatureSelector<State>('app');

// export const getIsLive = createSelector(getAppFeatureStore, data => data.isLive);

export const getMe = createSelector(getAppFeatureStore, state => state.user);

export const getNotification = createSelector(
  getAppFeatureStore,
  state => state.notificationCount
);

export const getUserError = createSelector(
  getAppFeatureStore,
  state => state.userError
);
export const getUserLoading = createSelector(
  getAppFeatureStore,
  state => state.userLoading
);

export const getIsAuthenticated = createSelector(
  getAppFeatureStore,
  state => state.isAuthenticated
);

export const getShowPassword = createSelector(
  getAppFeatureStore,
  state => state.showPassword
);
